import { Component, TemplateRef, ViewChild } from '@angular/core';
import { MatSnackBarConfig } from '@angular/material/snack-bar';

@Component({
    selector: 'app-matSnackBarConfig',
    templateUrl: './matSnackBarConfig.component.html',
    styleUrls: ['./matSnackBarConfig.component.scss'],
})
export class MatSnackBarConfigComponent {

    config = new MatSnackBarConfig();

    @ViewChild('customSnackBar') customSnackBar: TemplateRef<any>;

    constructor(
    ) {

    }

    returnMatSnackBarConfig(item: string): any{
        this.config.duration = 6000;
        this.config.horizontalPosition = 'right';
        this.config.verticalPosition = 'top';

        if (item == 'info'){
            this.config.panelClass = ['snack-bar-custom-info', 'mat-simple-snackbar-action']; 
            return this.config;
        } else if (item == 'danger'){
            this.config.panelClass = ['snack-bar-custom-danger', 'mat-simple-snackbar-action']; 
            return this.config;
        } else if (item == 'warning'){
            this.config.panelClass = ['snack-bar-custom-warning', 'mat-simple-snackbar-action']; 
            return this.config;
        } else if (item == 'success'){
            this.config.panelClass = ['snack-bar-custom-success', 'mat-simple-snackbar-action']; 
            return this.config;
        }

    }
    
}
